export default __webpack_public_path__ + "static/media/zapsplat_multimedia_game_sound_brick_set_down_003_67449.8a975204.mp3";